import { mixpanel } from '@fiverr-private/obs';
import {
    MIXPANEL_EVENT_PROPERTIES,
    MIXPANEL_GENERIC_EVENTS,
} from '../../../../../shared/mixpanel';
import { getLogoPositionReport } from '../../utils/getLogoPositionReport';
import { getVariationNumberReport } from '../../utils/getVariationNumberReport';
import { Favorite, Project } from '../../utils/types';

export const reportRemovedFromFavorites = (
    project: Project,
    variationId: string,
    favorites: Favorite[]
) =>
    mixpanel.track(MIXPANEL_GENERIC_EVENTS.PAGE_ACTION, {
        ...getLogoPositionReport(favorites, project.id),
        ...getVariationNumberReport(project, variationId),
        [MIXPANEL_EVENT_PROPERTIES.SELLER_ID]: project.user_id,
        [MIXPANEL_EVENT_PROPERTIES.PROJECT_ID]: project.id,
        [MIXPANEL_EVENT_PROPERTIES.VARIATION_ID]: variationId,
        [MIXPANEL_EVENT_PROPERTIES.ACTION]:
            'My Favorites - Remove From Favorites',
    });
